import $http from '../assets/js/http'

export function getList (params, enableLoading = true) {
  $http.custom(params, {moduleId: '1301', enableLoading: enableLoading})
  return $http.post('/advertiser/query/list', params)
}

export default {
  getList
}



// WEBPACK FOOTER //
// ./src/api/advertiser.js